import HashEvents from '@gameday/core/events/HashEvents';

export default HashEvents;
